module.exports = __webpack_public_path__ + "static/assets/07f06a48fbba576dfce5d79e6d0c3523.png";